<script setup lang="ts">
import { useNamespace } from '@zoryn/hooks'

const props = defineProps<{
  label: string
  audited?: boolean
}>()

const ns = useNamespace('ai-scope-badge')
</script>

<template>
  <span :class="[ns.b(), ns.is('audited', audited)]">{{ label }}</span>
</template>
